import session from "./session.js";

/**
 * Preload application dependencies, then initialize the application.
 *
 * @param {application} instance - Instance of the application to use
 * @param {object} options - Application options sent from the backend
 * @param {string} options.lang - Language to use in the application
 * @param {object} options.theme - Theming options
 */
export default function loadApplication({
	instance,
	options: { lang = "en-US", theme } = {},
}) {
	return Promise.all([
		waitForTheDocumentToBeReady(),
		session.setLanguage(lang),
	]).then(() => {
		theme && instance.setTheme(theme);
		instance.initialize();
	});
}

/**
 * Wait for the DOM to be reactive and for the CSS to be loaded.
 *
 * @return {Promise} Resolves when the document is ready
 */
function waitForTheDocumentToBeReady() {
	return new Promise((resolve) => {
		if (document.readyState !== "loading") {
			resolve();
			return;
		}
		document.addEventListener("DOMContentLoaded", resolve);
	});
}
